import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RemoteSession, RowActionButton } from '@mss/mss-component-library';
import revokeSession from './RevokeSessionModal';
import { Tooltip } from 'antd';
import { faBan } from '@fortawesome/free-solid-svg-icons';
type RevokeSessionRowButton = {
  session: RemoteSession;
  fetchSession: () => void;
};

export default function RevokeSessionRowButton({
  session,
  fetchSession,
}: RevokeSessionRowButton) {
  const [t] = useTranslation(['remoteAccess', 'common']);

  return (
    <Tooltip title={t('Revoke remote session')}>
      <RowActionButton
        onClick={() => revokeSession(t, session, fetchSession)}
        data-ta="StopSessionRowButton"
        shape="circle"
        style={{ border: 'none' }}
      >
        <FontAwesomeIcon icon={faBan} />
      </RowActionButton>
    </Tooltip>
  );
}
